import BaseClassifier from "@/models/server/BaseClassifier";
import {ExpenseType} from "@/models/Enums";

export default class Expense extends BaseClassifier {
    public equipmentType : string = "";

    public hourlyInvoiced: boolean = false;

    public expenseType: ExpenseType = ExpenseType.Unknown;

    public isExpense: boolean = true;
}